import styled from 'styled-components';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  grid-gap: 30px;
`;

export const GridCol = styled.div`
  grid-column-start: span ${(p) => p.$columns};
`;

export default {
  Grid,
  GridCol
}
